import React, { useState } from 'react';
import Swal from 'sweetalert2';

interface ChangePasswordModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (currentPassword: string, newPassword: string) => Promise<void>;
  userName: string;
  requireCurrentPassword?: boolean;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ show, onClose, onSubmit, userName, requireCurrentPassword = true }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validations
    if (requireCurrentPassword && !currentPassword) {
      Swal.fire('Erro', 'Digite a senha atual', 'error');
      return;
    }

    if (password.length < 6) {
      Swal.fire('Erro', 'A senha deve ter no mínimo 6 caracteres', 'error');
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire('Erro', 'As senhas não coincidem', 'error');
      return;
    }

    setLoading(true);
    try {
      await onSubmit(currentPassword, password);
      Swal.fire('Sucesso', 'Senha alterada com sucesso!', 'success');
      setCurrentPassword('');
      setPassword('');
      setConfirmPassword('');
      onClose();
    } catch (error: any) {
      Swal.fire('Erro', error.message || 'Erro ao alterar senha', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Alterar Senha - {userName}</h5>
            <button type="button" className="close" onClick={onClose} disabled={loading}>
              <span>&times;</span>
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {requireCurrentPassword && (
                <div className="form-group">
                  <label htmlFor="currentPassword">Senha Atual *</label>
                  <input
                    type="password"
                    className="form-control"
                    id="currentPassword"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    required
                    placeholder="Digite sua senha atual"
                    disabled={loading}
                  />
                </div>
              )}
              <div className="form-group">
                <label htmlFor="password">Nova Senha *</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={6}
                  placeholder="Mínimo 6 caracteres"
                  disabled={loading}
                />
                <small className="form-text text-muted">Mínimo de 6 caracteres</small>
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirmar Nova Senha *</label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  minLength={6}
                  placeholder="Digite a senha novamente"
                  disabled={loading}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Alterando...' : 'Alterar Senha'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
